export default class JobPermissions {
  public canChangeContactDetails = false
  public canTakeManualPayments = false
}
